// modules
import { createSelector } from 'reselect'
import { get } from 'lodash'

type PatientListTaskModalType = {
  fullName: string
  patientId: string
  uuid: string
}

const tasks = (state = {}) => get(state, ['tasks'], {})

export const editableTask$ = createSelector(tasks, (tasks = {}) =>
  get(tasks, ['editableTask'], {})
)

export const defaultCommentTask$ = createSelector(tasks, (tasks = {}) =>
  get(tasks, ['defaultCommentTask'], {})
)

export const isAddTaskModalVisible$ = createSelector(tasks, (tasks = {}) =>
  get(tasks, ['isAddTaskModalVisible'], false)
)

export const patientListTaskModal$ = createSelector(tasks, (tasks = {}) =>
  get(tasks, ['patientListTaskModal'], []).map(
    ({ fullName, patientId, uuid }: PatientListTaskModalType) => ({
      key: uuid,
      title: `${fullName} (${patientId})`,
      value: uuid
    })
  )
)

export const createdNewTask$ = createSelector(tasks, (tasks = {}) =>
  get(tasks, ['createdNewTask'], false)
)

export const taskHistoryItems$ = createSelector(tasks, (tasks = {}) =>
  get(tasks, ['taskHistoryItems'], {})
)

export const editableTaskComments$ = createSelector(tasks, (tasks = {}) =>
  get(tasks, ['editableTaskComments'], {})
)
